<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <Title tag="h1" v-if="section">{{ section.title }}</Title>
          <Title tag="h1" v-else>Sección no encontrada</Title>
          <Content
            v-if="section && section.content"
            :content="section.content"
          />
          <p v-else>No hay contenido disponible en esta sección</p>
        </ColumnUi>
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(section, index) in sections" :key="index">
              <router-link
                v-if="!section || currentSectionSlug != section.href"
                :to="section.href"
              >
                {{ section.title }}
              </router-link>
              <span v-else>
                {{ section.title }}
              </span>
            </li>
          </List>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getLaboratories } from "@/laboratories.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import { useRoute } from "vue-router";
import Content from "@/components/common/Content.vue";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    Content
  },
  setup() {
    const paramLaboratory = useRoute().params.laboratory;
    const currentSectionSlug = useRoute().fullPath;
    const paramSection = useRoute().params.section;
    const laboratory = getLaboratories(process.env.VUE_APP_PREFIX)[
      paramLaboratory
    ];
    const sections = [];
    laboratory.forEach(section => {
      sections.push({
        title: section.title,
        href: `/laboratorio/${paramLaboratory}/${section.slug}`
      });
    });
    const section =
      laboratory && laboratory.find(section => section.slug == paramSection);
    return {
      section,
      sections,
      currentSectionSlug
    };
  }
};
</script>
